import { Logo } from '@/UI/Logo';
import { ProfilePreview } from './ProfilePreview';
import { ListClients } from './ListClients';
import { LogoutButton } from './LogoutButton';
import { Link } from 'react-router-dom';

export const Aside = () => {
  return (
    <aside className="w-72 h-screen bg-card px-6 flex flex-col">
      <Link to="/">
        <Logo className="mt-10" />
      </Link>

      <ProfilePreview />

      <ListClients />

      <LogoutButton />
    </aside>
  );
};
